import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { makeStyles } from '@material-ui/core/styles';
import { InsuranceInformation } from './insuranceInformation';
import { InsuranceInformationBaseStore } from '@roc/feature-insurance-review';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type InsuranceInformationDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
  store: InsuranceInformationBaseStore;
  loanId: string;
};

const useStyles = makeStyles(theme => ({
  dialogPadding: {
    '& .MuiDialogContent-root': {
      padding: '0 24px',
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: 0
    }
  }
}));

export const InsuranceInformationDialog = observer(
  (props: InsuranceInformationDialogProps) => {
    const { open, onClose, store, loanId, document } = props;
    const taskId = document?.taskId;
    const classes = useStyles();

    const getContent = () => {
      return (
        <InsuranceInformation
          store={store}
          loanId={loanId}
          taskId={taskId?.toString()}
          handleClose={onClose}
        />
      );
    }

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            className={classes.dialogPadding}
            open={open}
            title='Insurance Information'
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            className={classes.dialogPadding}
            open={open}
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
          />
        )}
      </>
    );
  }
);
